<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500; font-size: 14px"
      >
        List of Pickup Carrier Slots
      </div>
      <v-spacer> </v-spacer>

      <v-btn
        small
        color="primary"
        v-if="checkPermission('app_pickup:add_pickup_carrier_slot')"
        @click="$router.push('/pickup-slot/0')"
        >Add Pickup Slot</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="slotList"
      :loading="loader"
      :search="search"
      :server-items-length="total"
      class="elevation-1 custom-icon-size"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.status`]="{ item }">
        <span
          :class="
            item.status == 1
              ? 'badge-active'
              : item.status == 3
              ? 'badge-excluded'
              : 'badge'
          "
        >
          {{
            item.status == 1
              ? "Active"
              : item.status == 3
              ? "Excluded"
              : "In-active"
          }}
        </span>
      </template>

      <template v-slot:[`item.schedule_date`]="{ item }">
        <span v-if="item.schedule_date">{{
          item.schedule_date | localMoment | moment("DD MMM, YYYY")
        }}</span>
      </template>

      <template v-slot:[`item.start_slot_time`]="{ item }">
        {{ item.start_slot_time }}
        <span v-if="item.end_slot_time">-{{ item.end_slot_time }}</span>
      </template>
      <template v-slot:[`item.slot_type`]="{ item }">
        {{ firstLetterCapital(item.slot_type) }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{ item.created_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
        <br /><span v-if="item.created_by">({{ item.created_by }})</span>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        {{ item.updated_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
        <br /><span v-if="item.updated_by">({{ item.updated_by }})</span>
      </template>
      <template v-slot:[`item.excluded_weekdays`]="{ item }"
        >{{ checkDays(item.excluded_weekdays) }}
      </template>

      <template v-slot:top>
        <template>
          <v-form ref="form">
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="carrier_ids"
                  label="Select Carrier"
                  class="pt-0 pb-0"
                  item-text="name"
                  placeholder="Start typing to Search"
                  item-value="id"
                  :items="activeCarriersListTypes"
                  outlined
                  small-chips
                  multiple
                  @focus="fetchCarriers()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="country_ids"
                  :items="countries"
                  label="Select Country"
                  placeholder="Start typing to Search"
                  item-text="name"
                  item-value="id"
                  outlined
                  small-chips
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="slot_type"
                  :items="slots_types"
                  outlined
                  label="Slot Type"
                  item-text="text"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  outlined
                  label="Status"
                  item-text="text"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class=""
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>

      <template
        v-slot:[`item.action`]="{ item }"
        v-if="checkPermission('app_pickup:edit_pickup_carrier_slot')"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small-chips class="mr-2" v-on="on" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit Slot</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {},
  computed: {},
  data: () => ({
    weeks: [
      {
        text: "Monday",
        value: 0,
      },
      {
        text: "Tuesday",
        value: 1,
      },
      {
        text: "Wednesday",
        value: 2,
      },
      {
        text: "Thursday",
        value: 3,
      },
      {
        text: "Friday",
        value: 4,
      },
      {
        text: "Saturday",
        value: 5,
      },
      {
        text: "Sunday",
        value: 6,
      },
    ],
    options: {},
    carrier_ids: [],
    city_id: null,
    country_ids: [],
    activeCarriersListTypes: [],
    zipcode: null,
    slot_type: "",
    status: "",
    from_date: "",
    to_date: "",
    dateMenu: false,
    dateMenuTo: false,
    statuses: [
      {
        text: "Active",
        value: 1,
      },
      {
        text: "InActive",
        value: 0,
      },
      {
        text: "Excluded",
        value: 3,
      },
    ],
    slots_types: [
      {
        text: "Standard",
        value: "standard",
      },
      {
        text: "Public Holiday",
        value: "public_holiday",
      },
      {
        text: "Customized",
        value: "customized",
      },
    ],
    headers: [
      {
        text: "Carrier",
        value: "carrier_id",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },
      {
        text: "Pickup Country",
        value: "country_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Slot Type",
        value: "slot_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Weekday",
        value: "weekday",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Schedule Date",
        value: "schedule_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Slot Time",
        value: "start_slot_time",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "120px",
      },

      {
        text: "Excluded Weekdays",
        value: "excluded_weekdays",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "130px",
      },
      {
        text: "Updated  At (By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "130px",
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    slotList: [],
    editedIndex: -1,
    loader: false,
    statusLoader: false,
    carrierId: null,
    active: "",
    name: "",
    filtersArr: {},
    carrierForm: false,
    carrierDetail: {},
    saveLoader: false,
    addList: {},
    total: 0,
    countries: [],
    cityLoader: false,
    cities: [],
    lockers: [
      {
        text: "Yes",
        value: 1,
      },
      {
        text: "No",
        value: 0,
      },
    ],
  }),

  async created() {
    this.getAddCarrierList();
    this.getCountryList();
    await this.fetchCarriers();
  },
  watch: {
    options: {
      handler() {
        this.fetchSlot();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getSlot",
      "snackBar",
      "getAddCarrier",
      "getCarriersDropdown",
      "getCountries",
      "fetchCityList",
    ]),
    checkDays(valuesToFind) {
      if (valuesToFind) {
        const result = this.weeks
          .filter((week) => valuesToFind.includes(week.value))
          .map((week) => week.text);
        return result.join(", ");
      }
    },
    editItem(item) {
      this.$router.push(`/pickup-slot/${item.id}`);
    },
    getCountryList(id) {
      this.getCountries(id).then((res) => {
        this.countries = res.data;
      });
    },
    async fetchCarriers() {
      if (this.activeCarriersListTypes.length) return;
      await this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.activeCarriersListTypes = res.data.filter((item) => item.active);
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getAddCarrierList() {
      this.getAddCarrier().then((res) => {
        this.addList = res.data;
        this.ServiceTypes();
      });
    },
    fetchSlot() {
      this.loader = true;
      this.getSlot({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.slotList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    clearInput(val) {
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.country_ids = [];
      this.slot_type = null;
      this.status = null;
      this.to_date = null;
      this.from_date = null;
      this.carrier_ids = [];
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        carrier_id: this.carrier_ids.join(","),
        slot_type: this.slot_type,
        start_date: this.from_date,
        end_date: this.to_date,
        country_id: this.country_ids.join(","),
        status: this.status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.loader = true;
      this.options.page = 1;
      this.allFilters();
      this.fetchSlot();
    },
  },
};
</script>
<style>
.carrier-logo {
  max-width: 100px;
  height: 25px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-excluded {
  display: inline-block;
  padding: 4px 10px;
  background-color: orange;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
